<!--
  --
  -- 性別入力コンポーネント
  --
  -->
<template>
  <v-radio-group
    label="性別"
    v-model="form.gender"
    :rules="[rule.required('性別'), rule.gender]"
  >
    <v-radio
      v-for="item in options"
      :key="item.code"
      :label="item.text"
      :value="item.code"
    />
  </v-radio-group>
</template>

<script>
import * as C from '@/consts'

export default {
  name: 'CProfileGender',
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    options: [
      // ISO 5218
      { code: C.MALE, text: '男性' },
      { code: C.FEMALE, text: '女性' },
      { code: C.SEX_NOT_APPLICABLE, text: '回答しない' }
    ]
  })
}
</script>
